export const blog = '/allt-um-bila'
export const news = '/frettir'
export const events = '/vidburdir'
export const testdrive = '/reynsluakstur'